<template>
	<div class="search-product">
		<div class="el-search vue-top-padding radius">
			<div class="el-left">
				<el-button
					type="primary"
					size="small"
					v-hasPerm="['upgrade:vmc:add']"
					icon="el-icon-plus"
					@click="addFirmware"
					>{{ $t("common.add") }}</el-button
				>
			</div>
			<div class="el-right">
				<el-form
					ref="firmware"
					:model="search"
					:inline="true"
					label-width="10px"
					size="small"
					class="demo-form-inline el-input-height"
				>
					<el-form-item>
					<el-date-picker
						v-model="dateTime"
						type="datetimerange"
						format="yyyy-MM-dd HH:mm:ss"
						value-format="yyyy-MM-dd HH:mm:ss"
						range-separator="-"
						:picker-options="pickerOptions"
						:default-time="['00:00:00', '23:59:59']"
						:start-placeholder="$t('searchProductProfit.start')"
						:end-placeholder="$t('searchProductProfit.end')"
					>
					</el-date-picker>
					</el-form-item>
					<el-form-item prop="fileName">
						<el-input
							v-model="search.fileName"
							:placeholder="$t('upgrade.fileName')"
							@input="onSubmit"
						></el-input>
					</el-form-item>
					<el-form-item prop="version">
						<el-input
							v-model="search.version"
							:placeholder="$t('upgrade.firmwareId')"
							@input="onSubmit"
						></el-input>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="onSubmit" icon="el-icon-search">{{
							$t("common.search")
						}}</el-button>
						<el-button
							@click="resetSearch('firmware')"
							icon="el-icon-refresh"
							>{{ $t("common.reset") }}</el-button
						>
					</el-form-item>
				</el-form>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "SearchProduct",
	props: {
		search: Object,
	},
	data() {
		return {
			pickerOptions: {
				shortcuts: [
					{
						text: this.$t("TimeControl.week"),
						onClick(picker) {
						const end = new Date();
						end.setHours(23, 59, 59, 999);
						const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
							picker.$emit("pick", [start, end]);
						},
					},
					{
						text: this.$t("TimeControl.month"),
						onClick(picker) {
						const end = new Date();
						end.setHours(23, 59, 59, 999);
						const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
							picker.$emit("pick", [start, end]);
						},
					},
					{
						text: this.$t("TimeControl.year"),
						onClick(picker) {
						const end = new Date();
						end.setHours(23, 59, 59, 999);
						const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
							picker.$emit("pick", [start, end]);
						},
					},
				],
			},
			dateTime: "",
		};
	},
	methods: {
		addFirmware() {
			this.$emit("addFirmware");
		},
		onSubmit() {
			if (this.dateTime && this.dateTime.length > 0) {
				this.search.startTime = this.dateTime[0];
				this.search.endTime = this.dateTime[1];
			}
			this.$emit("onSubmit", this.search);
		},
		resetSearch(formName) {
			this.dateTime = null;
			this.$refs[formName].resetFields();
			this.$toolUtil.clearForm(this.search);
			this.$emit("resetSearch", this.search);
		},
	},
};
</script>

<style lang="sass"></style>
